/*
  Points de pagination des carrousels.

  Dawn dessine déjà les points (`component-slider.css`), mais ne les anime que
  dans `SlideshowComponent`, réservé au diaporama pleine largeur. Les
  carrousels ordinaires du site sont des `<slider-component>` : ils changent
  bien de carte, ils émettent bien l'événement `slideChanged`, mais personne
  n'écoute pour allumer le bon point.

  Ce fichier fait les deux liaisons manquantes :
    — à chaque changement de carte, le point correspondant s'allume ;
    — au clic sur un point, la piste défile jusqu'à la carte voulue.

  Il ne s'occupe que des carrousels qui portent des points dans leur balisage :
  ajouter le bloc `.slider-counter--dots` à une autre section suffit à l'y
  activer, sans toucher à ce fichier.
*/

(function () {
  'use strict';

  function allumer(points, rang) {
    points.forEach(function (point, index) {
      var actif = index === rang;
      point.classList.toggle('slider-counter__link--active', actif);
      if (actif) {
        point.setAttribute('aria-current', 'true');
      } else {
        point.removeAttribute('aria-current');
      }
    });
  }

  function equiper(composant) {
    var points = Array.from(composant.querySelectorAll('.slider-counter__link--dots'));
    var piste = composant.querySelector('.slider');
    if (points.length === 0 || piste === null) return;

    // `slideChanged` est émis par SliderComponent, avec la position en base 1.
    composant.addEventListener('slideChanged', function (evenement) {
      allumer(points, evenement.detail.currentPage - 1);
    });

    points.forEach(function (point, rang) {
      point.addEventListener('click', function () {
        var cartes = piste.querySelectorAll('.slider__slide');
        var cible = cartes[rang];
        if (!cible) return;

        // On mesure depuis la PREMIÈRE carte, pas depuis la piste : les deux
        // n'ont pas forcément le même parent positionné, et la différence
        // décalerait le défilement d'un demi-écran.
        var depart = cartes[0].offsetLeft;
        piste.scrollTo({ left: cible.offsetLeft - depart, behavior: 'smooth' });
        allumer(points, rang);
      });
    });
  }

  function demarrer() {
    document.querySelectorAll('slider-component').forEach(equiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
